/* eslint-disable react/prop-types */
import React from "react";
import { Button, Empty, Divider, Col, Layout, Row, Typography } from "antd";
import FilmCard from "../../../components/card";
import { useLeadCapture } from "../../../components/lead-capture";

const { Title } = Typography;

const Projects = ({ projects, linkSearch = "" }) => {
  const openLeadCapture = useLeadCapture();
  return (
    <>
      {projects &&
        projects.filter((item) => item.distributionStatus == "live").length >
          0 && (
          <Layout>
            <Row>
              <Title level={4}>Live Projects</Title>
            </Row>
            <Row>
              {projects
                .filter((item) => item.distributionStatus == "live")
                .map((item) => (
                  <FilmCard
                    item={item}
                    key={item.uid}
                    linkSearch={linkSearch}
                  />
                ))}
            </Row>
          </Layout>
        )}

      {projects.filter(
        (item) => item.distributionStatus != "live" && item.rating >= 6.5
      ).length > 0 ? (
        <Layout>
          <Row>
            <Title level={4}>Eligible Projects</Title>
          </Row>
          <Row>
            {projects
              .filter(
                (item) =>
                  item.distributionStatus != "live" && item.rating >= 6.5
              )
              .map((item) => (
                <FilmCard item={item} key={item.uid} linkSearch={linkSearch} />
              ))}
          </Row>
        </Layout>
      ) : (
        <>
          {projects &&
            projects.filter((item) => item.distributionStatus == "live")
              .length <= 0 && (
              <>
                <Col
                  className="vc-panel vc-submit-strip"
                  xs={{ span: 24 }}
                  lg={{ span: 24 }}
                  style={{
                    padding: "24px",
                  }}
                >
                  <Empty
                    status="500"
                    title="You have no projects"
                    subTitle="Request access — we're invite-only and reviewing the queue."
                    description={
                      <span>
                        You do not have {projects.length > 0 ? "other" : "any"}{" "}
                        eligible projects yet. Join the queue and we&apos;ll get
                        back to you shortly.
                      </span>
                    }
                  >
                    <Button type="primary" onClick={() => openLeadCapture()}>
                      Request Access
                    </Button>
                  </Empty>
                </Col>
                <Row>
                  <Divider />
                  <Title level={4}>Non Eligible Projects</Title>
                  <Divider />
                  {projects
                    .filter(
                      (item) =>
                        item.distributionStatus != "live" && item.rating < 6.5
                    )
                    .map((item) => (
                      <FilmCard item={item} key={item.uid} deactive />
                    ))}
                  <Col xs={{ span: 24 }} className="vc-submit-strip">
                    <Button type="primary" onClick={() => openLeadCapture()}>
                      Request access for another film
                    </Button>
                  </Col>
                  <Divider />
                </Row>
              </>
            )}
        </>
      )}
    </>
  );
};
export default Projects;
